<template>
    <div class="row">
        <div class="col-lg-12">
            <div v-if="errors.length > 0" class="alert alert-danger" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <span v-for="error in errors">{{error}}<br/></span>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">

                        <label for="name">Name <span class="text-danger text-xs">*</span></label>

                        <input class="form-control" type="text" name="name" v-model="contactlist.name" id="name" placeholder="" autofocus="" required="">
                    </div><!--form-group-->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">

                        <label>Contacts <span class="text-danger text-xs">*</span></label>
                        <div>
                            <button class="btn btn-success btn-icon-split" data-toggle="modal" data-target="#import-modal">
                            <span class="icon text-white-50">
                                <i class="fas fa-upload"></i>
                            </span>
                                <span class="text">Import From CSV</span>
                            </button>
                        </div>
                        <div class="modal fade" id="import-modal" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5>Import Contacts from CSV</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <vue-csv-import v-model="contactlist.contacts" :map-fields="{name: 'Name', email: 'Email', company: 'Company Name', job_title: 'Job Title', tel: 'Tel'}" buttonClass="btn btn-primary" loadBtnText="Import" canIgnore="true">
                                            <template slot="hasHeaders" slot-scope="{headers, toggle}">
                                                <div class="custom-control custom-switch" style="margin-left: -1.25rem;">
                                                    <input type="checkbox" class="custom-control-input" id="hasHeaders"  :value="headers" @change="toggle">
                                                    <label class="custom-control-label" for="hasHeaders">File contains header?</label>
                                                </div>
                                            </template>
                                            <template slot="error">
                                                Only CSV is allowed
                                            </template>
                                            <template slot="next" slot-scope="{load}">
                                                <button class="btn btn-success btn-icon-split" @click.prevent="load">
                                                    <span class="icon text-white-50">
                                                        <i class="fas fa-play"></i>
                                                    </span>
                                                    <span class="text">Match Fields</span>
                                                </button>
                                            </template>
                                        </vue-csv-import>
                                        <span v-if="contactlist.contacts.length == 0" class="text-danger">Please complete the field mapping</span>
                                        <span v-if="contactlist.contacts.length > 0" class="text-success">{{contactlist.contacts.length}} contacts found</span>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-secondary btn-icon-split" data-dismiss="modal">
                                            <span class="icon text-white-50">
                                                <i class="fas fa-times"></i>
                                            </span>
                                            <span class="text">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div><!--form-group-->
                </div><!--col-->
            </div><!--row-->
            <div class="row">
                <div class="col mb-3">
                    <vue-bootstrap4-table :rows="contactlist.contacts" :columns="dt.columns" :config="dt.config" :classes="dt.classes">
                        <template slot="sort-asc-icon">
                            <i class="fas fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                            <i class="fas fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                            <i class="fas fa-sort text-gray-200"></i>
                        </template>
                    </vue-bootstrap4-table>

                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="form-group mb-0 clearfix">

                        <button class="btn btn-success btn-icon-split" @click="save">
                            <span class="icon text-white-50">
                              <i class="fas fa-paper-plane"></i>
                            </span>
                            <span class="text">Save</span>
                        </button>
                    </div><!--form-group-->
                </div><!--col-->
            </div><!--row-->
        </div>
    </div>


</template>

<script>
    import { VueCsvImport } from 'vue-csv-import'
    import VueBootstrap4Table from 'vue-bootstrap4-table'

    var moment = require('moment')
    moment().format()

    export default {
        name: 'ContactListForm',
        data() {
            return {
                regex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(\s?,\s?(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))?$/,
                contactlist: {
                    hashid: null,
                    name: null,
                    contacts: [],
                },
                errors: [],
                //stepper: null,
                dt: {
                    classes: {
                        table: {
                            "table-striped": true,
                        }
                    },
                    columns: [
                        {
                            label: "Name",
                            name: "name",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Email",
                            name: "email",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            //slot_name: "action"
                        },
                        {
                            label: "Company Name",
                            name: "company",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Job Title",
                            name: "job_title",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Tel",
                            name: "tel",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                    ],
                    config: {
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        per_page: 50,
                        per_page_options:  [50,  100,  200,  500],
                    }
                },
            }
        },
        components: {
            VueCsvImport,
            VueBootstrap4Table,
        },
        props: {
            hashid: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
        },
        watch: {
        },
        methods: {

            save() {
                axios.post('/contactlist', {'contactlist': this.contactlist},).then((response) => {
                    Swal.fire({
                        title: 'Success',
                        text: 'Record saved successfully',
                        icon: 'success',
                        confirmButtonText: 'Done'
                    }).then((result) => {
                        location.href='/contactlist'
                    })
                }).catch((error) => {
                    // TODO:  handle validation error
                    Swal.fire({
                        title: 'Error',
                        text: 'There are problems in the form',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        this.errors = error.response.data.errors
                        window.scrollToTop()
                    })
                })
            }
        },
        mounted() {
            if (this.hashid.length > 0)
            {
                axios.get('/api/contactlist/'+this.hashid).then((response) => {
                    this.contactlist = _.merge(this.event,response.data.contactlist)
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to retrieve record',
                        icon: 'error',
                        confirmButtonText: 'Dismiss'
                    }).then((result) => {
                        location.href='/contactlist'
                    });
                });
            }


        }
    }
</script>
<style scoped>
</style>
